module.exports = __webpack_public_path__ + "img/logo.a0654247.png";